import { api } from '@orisini/ui/lib/api'

export interface AccountDto {
  id: string
  label: string
  username: string | null
  avatarUrl: string | null
  profileDir: string
  timezone: string | null
  status: 'unlinked' | 'ok' | 'needs_login' | 'error'
  statusMessage: string | null
  lastSessionCheckAt: number | null
  paused: boolean
  maxPostsPerHour: number
  minGapMinutes: number
  latePolicy: 'post_late' | 'requeue' | 'skip'
  lateGraceMinutes: number
  defaultBoardId: string | null
  sortOrder: number
  createdAt: number
}

export interface AccountsResponse {
  accounts: AccountDto[]
  limit: { used: number; max: number }
}

export const accountsApi = {
  list: () => api.get<AccountsResponse>('/accounts'),
  update: (id: string, patch: Partial<AccountDto>) =>
    api.patch<{ account: AccountDto }>(`/accounts/${id}`, patch),
  pause: (id: string) => api.post<{ ok: true }>(`/accounts/${id}/pause`),
  resume: (id: string) => api.post<{ ok: true }>(`/accounts/${id}/resume`),
  previewDelete: (id: string) =>
    api.delete<{ ok: true; dryRun: true; pinsToDelete: number }>(`/accounts/${id}?dryRun=1`),
  remove: (id: string) => api.delete<{ ok: true; pinsDeleted: number }>(`/accounts/${id}`),
}

export const STATUS_LABEL: Record<AccountDto['status'], { text: string; className: string }> = {
  unlinked: { text: 'Not connected', className: 'text-muted-foreground' },
  ok: { text: 'Session active', className: 'text-emerald-500' },
  needs_login: { text: 'Needs sign in again', className: 'text-amber-500' },
  error: { text: 'Problem', className: 'text-destructive' },
}
